import React from "react";
import ReactMultiSelectAsync from "../../Components/Inputs/ReactMultiSelectAsync";
import ReactTreeSelect from "../../Components/Inputs/ReactTreeSelect";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";

const flatten = arr => {
    let result = [];
    arr.forEach(function (item) {
        result.push(item);
        if (Array.isArray(item.children)) {
            result = result.concat(flatten(item.children));
        }
    });
    return result;
}

export default function ({ register, errors, control, data, watch, setValue, getValues, searchProduct}) {

    const flattenedCategories = data?.categories ? flatten(data?.categories) : []

    return (<>
        <ReactSelectInput
          label="Shop (Filter)"
          name="shop_id"
          className="col-md-12 col-sm-6 pt-3"
          options={data?.shops}
          control={control}
          errorMessage={errors?.shop_id}
        />

        <ReactTreeSelect
          label="Category (filter)"
          name="category_id"
          parentClasses="col-md-12 col-sm-12 pt-3"
          control={control}
          errorMessage={errors?.cat_id}
          options={data?.categories}
          value={data?.continueShopping?.category_id}
          setValue={setValue}
          callback={(categoryId)=> setValue('name', flattenedCategories?.find((item) => item.value == categoryId )?.label)}
          register={register}
        />

        <ReactMultiSelectAsync
            label="Products"
            name="products"
            placeholder="Choose Products"
            className="col-md-12 col-sm-6 pt-3"
            inputClassName="col-md-6"
            values={data?.products}
            errorMessage={errors?.products}
            control={control}
            search={searchProduct}
            defaultOptions={true}
            loadTrigger={watch('products')}
        />
    </>);
}